import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M21 14a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 1 0-2 0v4a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0-1-1m-9.71 1.71c.0951.091.2072.1624.33.21a.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l4-4a1.0041 1.0041 0 1 0-1.42-1.42L13 12.59V3a1.0002 1.0002 0 0 0-1.7071-.7071A1 1 0 0 0 11 3v9.59l-2.29-2.3a1.005 1.005 0 0 0-1.0943-.2177 1.006 1.006 0 0 0-.5434.5435A1.004 1.004 0 0 0 7.29 11.71z"
}), "Download", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
